// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
import el from 'air-datepicker/locale/el';

gsap.registerPlugin(ScrollTrigger);

const original = document.querySelector('.first-sec-bg')?.cloneNode(true);

window.insertClonedBgFirst = function insertClonedBgFirst() {
  const copy = original.cloneNode(true);
  document.querySelector('.body-bg')?.appendChild(copy);
};

window.bgFirstFixedAnimation = function bgFirstFixedAnimation() {
  const bgEl = document.querySelector('[data-first-parallax-bg]');
  const section = document.querySelector('[data-first-parallax-bg-sec]');
  const btnOurWorkWr = document.querySelector('.btn-our-work-wr');
  const bodyBg = document.querySelector('.body-bg');
  const body = document.querySelector('body');
  const textArrowSec = document.querySelector('.text-arrow-type.text-sec');

  if (!bgEl || !section) {
    return;
  }

  let endY = window.innerHeight * 1.3;

  if (window.innerWidth <= 640) {
    endY = window.innerHeight / 1.5;
  } else if (window.innerWidth <= 1024) {
    endY = window.innerHeight / 1.4;
  }

  if (section?.classList.contains('for-footer-bg-wr')) {
    endY = 1000;
  }

  ScrollTrigger.create({
    trigger: section,
    start: 'top top',
    end: `${endY}px`,
    invalidateOnRefresh: true,
    // markers: true,
    onUpdate: (self) => {
      requestAnimationFrame(() => {
        const progress = self.progress;
        if (progress > 0.8) {
          if (!section.classList.contains('tap-latest-work-first-sec')) {
            pauseFirstGradientAnimation();
          }
          if (!section.classList.contains('tap-latest-work-first-sec')) {
            bodyBg.classList.remove('is-worked-first-fixed-bg');
            body.classList.remove('is-worked-first-fixed-bg');
          }
        } else if (progress > 0.6) {
          section.classList.add('is-hidden-gradient');
          if (btnOurWorkWr) {
            btnOurWorkWr.classList.add('is-hidden-gradient');
          }
          if (textArrowSec) {
            textArrowSec.classList.add('is-hidden-gradient');
          }
          if (!section.classList.contains('tap-latest-work-first-sec')) {
            bodyBg.classList.remove('is-worked-first-fixed-bg');
            body.classList.remove('is-worked-first-fixed-bg');
          }
        } else {
          section.classList.remove('is-hidden-gradient');
          if (btnOurWorkWr) {
            btnOurWorkWr.classList.remove('is-hidden-gradient');
          }
          if (textArrowSec) {
            textArrowSec.classList.remove('is-hidden-gradient');
          }
          if (!bodyBg.classList.contains('is-worked-first-fixed-bg')) {
            bodyBg.classList.add('is-worked-first-fixed-bg');
            body.classList.add('is-worked-first-fixed-bg');
            resumeFirstGradientAnimation();
          }
        }
      });
    },
  });
};

if (!document.querySelector('.bold-loader-new')) {
  const bodyBg = document.querySelector('.body-bg');
  const firstBgEL = document.querySelector('.first-sec-bg');
  const body = document.querySelector('body');

  if (firstBgEL && bodyBg) {
    bodyBg.prepend(firstBgEL);
    bodyBg.classList.add('is-worked-first-fixed-bg');
    body.classList.add('is-worked-first-fixed-bg');
  }

  bgFirstFixedAnimation();
} else {
  const bodyBg = document.querySelector('.body-bg');
  const firstBgEL = document.querySelector('.first-sec-bg');
  const body = document.querySelector('body');

  if (firstBgEL && bodyBg) {
    bodyBg.classList.add('is-worked-first-fixed-bg');
    body.classList.add('is-worked-first-fixed-bg');
  }
}

window.scrollTriggerRefreshFunc = function scrollTriggerRefreshFunc() {
  ScrollTrigger.refresh(true);
};
